import {styled, Text, TextTag} from '@volkswagen-onehub/components-core';
import React, {useEffect, useState} from 'react';
import {getLang, getTranslations} from '../../translations';
import {formatDistance} from '../../utils/format';
import {replaceStringWithJSX} from '../../utils/replace-string-with-jsx';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { Meta, VehicleResultInterface } from '../../types/old/vehicles';
import { ResponseSelector } from '../../types/globalapi/response-selector';
import useVehiclesQuery from '../../api/use-vehicles-query';
import { useAppliedFilterStore } from '../../store/filtersv2';
import UserLocation from '../../UserLocation';

const StyledText = styled(Text)`
  padding-top: calc(var(--textappearances-copy100-fontsize) * 1.15);
`;

const SummaryContainer = styled.div`
  grid-column: 1 / 2;
  grid-row: 1 / 2;

  @media screen and (max-width: 590px) {
    grid-column: 1 / 2;
    grid-row: 1 / 2;
  }
`;

export const Summary = () => {
  const {labels} = getTranslations();
  const lang = getLang();

  const [ total, setTotal ] = useState(0);
  const [ vehicleCount, setVehicleCount ] = useState(0);

  const getMetaData: ResponseSelector<VehicleResultInterface, Meta> = res => res?.meta as Meta;

  const { isLoading, data } = useVehiclesQuery<VehicleResultInterface, Meta>({ select: getMetaData });

  const pagination = (data as Meta)?.pagination;

  useEffect(() => {
    if (pagination) {
      setVehicleCount(pagination.current_page * pagination.per_page);
      setTotal(pagination.total);
    }
  }, [pagination])

  const { applied } = useAppliedFilterStore();
  const distance = applied.distance as number;


  return (
    isLoading
    ? <StyledText>
      <Skeleton width="40vw" height="20" borderRadius="0"/>
    </StyledText>
    : !(total && pagination && vehicleCount)
    ? <SummaryContainer>
      <StyledText tag={TextTag.p}>
        {replaceStringWithJSX(labels.view_summary_zero, {
          total: <Text tag={TextTag.span} bold>0</Text>,
          distance: (
            <Text tag={TextTag.span} bold>
              {formatDistance(distance, lang)}
            </Text>
          ),
          postalCode: <UserLocation inline />,
        })}
      </StyledText>
    </SummaryContainer>
    : <SummaryContainer>
      <StyledText tag={TextTag.p}>
        {replaceStringWithJSX(labels.view_summary, {
          range: (
            <Text tag={TextTag.span} bold>
              {vehicleCount - (pagination?.per_page - 1)}-
              {vehicleCount <= total ? vehicleCount : total}
            </Text>
          ),
          total: <Text tag={TextTag.span}>{total}</Text>,
          distance: (
            <Text tag={TextTag.span} bold>
              {formatDistance(distance, lang)}
            </Text>
          ),
          postalCode: <UserLocation inline />,
        })}
      </StyledText>
    </SummaryContainer>
  );
};
